import tr from "@/utils/Tr";

export const inquiryVideosGuides = () => [
    {
        imageSrc: "https://silkplm.com/wp-content/uploads/2025/02/Inspirations-quick-guide-1.png",
        imageAlt: "How to download a PDF with the Product Specification?",
        imageLink: "https://www.youtube.com/watch?v=WyG-96yETIk",
    },
    {
        imageSrc: "https://silkplm.com/wp-content/uploads/2025/02/Logo-P-spec.png",
        imageAlt: "Project Specification How to add or change your logo.",
        imageLink: "https://www.youtube.com/watch?v=cV73uUF9ulM",
    },
    {
        imageSrc: "https://silkplm.com/wp-content/uploads/2025/02/Top-Fields-P-Spec.png",
        imageAlt: "Project Specification Top Section Fields.",
        imageLink: "https://youtu.be/V-7kwyPuSTg",
    },
    {
        imageSrc: "https://silkplm.com/wp-content/uploads/2025/02/Photos-P-Spec.png",
        imageAlt: "Adding Photos to Project Specification.",
        imageLink: "https://youtu.be/n9A5vTMMIQk",
    },
    {
        imageSrc: "https://silkplm.com/wp-content/uploads/2025/02/Color-Vers-P-spec.png",
        imageAlt: "Color Versions in Project Specification.",
        imageLink: "https://youtu.be/Ji4rR_hL8yg",
    },
    {
        imageSrc: "https://silkplm.com/wp-content/uploads/2025/02/Tech-Det-P-Spec.png",
        imageAlt: "Technological Details in Project Specification.",
        imageLink: "https://youtu.be/v1J_NUye50c",
    },
    {
        imageSrc: "https://silkplm.com/wp-content/uploads/2025/02/MoE-P-Spec.png",
        imageAlt: "Methods of Execution in Project Specification.",
        imageLink: "https://youtu.be/SNqQDVQfaNI",
    },
    {
        imageSrc: "https://silkplm.com/wp-content/uploads/2025/02/Wash-Care-P-Spec.png",
        imageAlt: "Wash and Care in Project Specification.",
        imageLink: "https://youtu.be/QHcjY5gU8pg",
    },
    {
        imageSrc: "https://silkplm.com/wp-content/uploads/2025/02/Dimensions-P-Spec.png",
        imageAlt: "Construction Points in Project Specification.",
        imageLink: "https://youtu.be/rH4u2d5gfSY",
    },
    {
        imageSrc: "https://silkplm.com/wp-content/uploads/2025/02/Branding-P-spec.png",
        imageAlt: "Branding Details in Project Specification.",
        imageLink: "https://youtu.be/MRch0chbAfM",
    },
];